<template>

    <BaseTemplate app-name="Gestão de Ativos" page-title="">
        <template #content>
            <div class="w-full px-4 md:px-8">
                <!-- Abas -->
                <div class="mb-4 border-b border-gray-200 dark:border-gray-700">
                    <ul class="flex flex-wrap justify-center -mb-px text-sm overflow-x-auto overflow-y-hidden">
                        <li v-for="tab in ['equipments', 'kits', 'models']" :key="tab" class="mr-2">
                            <button @click="setActiveTab(tab)"
                                class="py-2 px-3 md:py-4 md:px-4 font-medium text-center rounded-t-lg transition-colors duration-200"
                                :class="activeTab === tab ? 'text-blue-600 border-b-2 border-blue-600 dark:text-blue-500 dark:border-blue-500' : 'text-gray-500 hover:text-gray-600 hover:border-gray-300 dark:text-gray-400 dark:hover:text-gray-300'">
                                {{ getTabName(tab) }}
                            </button>
                        </li>
                    </ul>
                </div>

<!-- Métricas -->
<!-- Métricas (colunas dinâmicas em lg de acordo com o tamanho de activeMetrics) -->
<div
  :class="[
    'grid gap-4 mb-8',
    'grid-cols-1',
    'sm:grid-cols-2',
    `lg:grid-cols-${ activeMetrics.length }`
  ]"
>
  <div
    v-for="(metric, index) in activeMetrics"
    :key="index"
    class="bg-white dark:bg-gray-800 rounded-lg shadow p-6"
  >
    <h3 class="text-lg font-semibold text-gray-700 dark:text-gray-300 mb-2">
      {{ metric.label }}
    </h3>
    <p class="text-3xl font-bold" :class="metric.color">{{ metric.value }}</p>
  </div>
</div>



                <!-- Conteúdo das Abas -->
                <AbaEquipamentos
  ref="abaEquipamentosRef" 
  v-if="activeTab === 'equipments'" 
  :unidades="unidades"
  :tipos="tipos"
  :models="models"
  :filters="filters.equipment"
  :sortColumn="sortColumn"
  :sortDirection="sortDirection"
  @sort-by="sortBy"
  @open-modal="openModal"
  @edit-equipment="editEquipment"
  @delete-equipment="deleteEquipment"
  @ver-detalhes="verDetalhesAtivo"
  @go-to-gerar-token="goToGerarToken"
  @apply-filters="applyFilters"
  @equipment-added="handleEquipmentAdded"
/>

                <AbaModelos 
                    v-if="activeTab === 'models'" 
                    :models="models"
                    :filters="filters.model"
                    @show-add-model-modal="showAddModelModal = true"
                    @edit-model="editModel"
                    @delete-model="deleteModel"
                />

                <AbaKits 
                    v-if="activeTab === 'kits'" 
                    :kits="equipmentKits"
                    :unidades="unidades"
                    :setores="setores"
                    :filters="filters.kit"
                    :showFilters="showFilters"
                    @toggle-filters="showFilters = !showFilters"
                    @show-add-kit-modal="showAddKitModal = true"
                    @ver-detalhes-kit="verDetalhesKit"
                    @delete-kit="deleteKit"
                    @kit-adicionado="handleKitAdicionado"
                    @apply-filters="applyFilters"
                />

            </div>
        </template>
    </BaseTemplate>

    <!-- Modais -->
    <ModalTemplate v-if="showAddEquipmentModal" @close="showAddEquipmentModal = false">
        <template #header>Adicionar Novo Equipamento</template>
        <template #body>
            <form @submit.prevent="addEquipment" class="space-y-4">
                <div>
                    <label for="equipmentSerial"
                        class="block text-sm font-medium text-gray-700 dark:text-gray-300">Serial Number</label>
                    <input type="text" id="equipmentSerial" v-model="newEquipment.serial_number" required
                        placeholder="Digite o Serial Number"
                        class="w-full border rounded-lg px-4 py-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white mb-3" />
                </div>
                <div>
                    <label for="equipmentTipo"
                        class="block text-sm font-medium text-gray-700 dark:text-gray-300">Tipo</label>
                    <select id="equipmentTipo" v-model="selectedTipo" required
                        class="w-full border rounded-lg px-4 py-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white mb-3">
                        <option value="" disabled>Selecione um tipo</option>
                        <option v-for="tipo in tipos" :key="tipo.id" :value="tipo.nome">{{ tipo.nome }}</option>
                    </select>
                </div>
                <div>
                    <label for="equipmentModelo"
                        class="block text-sm font-medium text-gray-700 dark:text-gray-300">Modelo</label>
                    <select id="equipmentModelo" v-model="selectedModelo" required
                        class="w-full border rounded-lg px-4 py-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white mb-3">
                        <option value="" disabled>Selecione um modelo</option>
                        <option v-for="model in filteredModelsByTipo" :key="model.id" :value="model.id">{{ model.nome }}
                        </option>
                    </select>
                </div>
                <div>
                    <label for="equipmentStatus"
                        class="block text-sm font-medium text-gray-700 dark:text-gray-300">Status</label>
                    <select id="equipmentStatus" v-model="newEquipment.status" required
                        class="w-full border rounded-lg px-4 py-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white mb-3">
                        <option value="Disponível">Disponível</option>
                        <option value="Em uso">Em uso</option>
                        <option value="Em manutenção">Em manutenção</option>
                    </select>
                </div>
                <div>
                    <label for="equipmentHost"
                        class="block text-sm font-medium text-gray-700 dark:text-gray-300">Host (Opcional)</label>
                    <select id="equipmentHost" v-model="newEquipment.host_id"
                        class="w-full border rounded-lg px-4 py-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white mb-3">
                        <option value="">Selecione um host (opcional)</option>
                        <option v-for="host in hosts" :key="host.id" :value="host.id">{{ host.nome }} ({{ host.ip_address }})</option>
                    </select>
                </div>
                <div class="flex justify-end">
                    <button type="submit"
                        class="flex-1 sm:flex-none bg-blue-600 text-white px-6 py-2.5 rounded-lg hover:bg-blue-700 transition-all duration-200 transform hover:scale-105 flex items-center justify-center gap-2 font-medium shadow-lg w-full sm:w-auto">
                        <PlusCircle class="w-5 h-5" />
                        <p>Adicionar</p>
                    </button>
                </div>
            </form>
        </template>
    </ModalTemplate>

    <ModalTemplate v-if="showAddRelatoriosModal" @close="showAddRelatoriosModal = false">
        <template #header>Gerar Relatórios</template>
        <template #body>
            <form @submit.prevent="gerarRelatorios" class="space-y-4">
                <div>
                    <label for="relatorioUnidade" class="block text-sm font-medium text-gray-700 dark:text-gray-300">Unidade</label>
                    <select id="relatorioUnidade" v-model="selectedUnidade"
                        class="w-full border rounded-lg px-4 py-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white mb-3">
                        <option value="">Todas as Unidades</option>
                        <option v-for="unidade in unidades" :key="unidade.id" :value="unidade.id">{{ unidade.nome }}</option>
                    </select>
                </div>

                <div>
                    <label for="relatorioPeriodo" class="block text-sm font-medium text-gray-700 dark:text-gray-300">Período</label>
                    <select id="relatorioPeriodo" v-model="selectedPeriodo" required
                        class="w-full border rounded-lg px-4 py-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white mb-3">
                        <option value="" disabled>Selecione o período</option>
                        <option value="ultimos_7_dias">Últimos 7 dias</option>
                        <option value="ultimos_30_dias">Últimos 30 dias</option>
                        <option value="customizado">Personalizado</option>
                    </select>
                </div>

                <div v-if="selectedPeriodo === 'customizado'">
                    <label for="dataInicio" class="block text-sm font-medium text-gray-700 dark:text-gray-300">Data de Início</label>
                    <input type="date" id="dataInicio" v-model="dataInicio" required
                        class="w-full border rounded-lg px-4 py-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white mb-3">

                    <label for="dataFim" class="block text-sm font-medium text-gray-700 dark:text-gray-300">Data de Fim</label>
                    <input type="date" id="dataFim" v-model="dataFim" required
                        class="w-full border rounded-lg px-4 py-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white mb-3">
                </div>

                <div>
                    <label for="relatorioStatus" class="block text-sm font-medium text-gray-700 dark:text-gray-300">Status</label>
                    <select id="relatorioStatus" v-model="selectedStatus" required
                        class="w-full border rounded-lg px-4 py-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white mb-3">
                        <option value="" disabled>Selecione o status</option>
                        <option value="Todos os Equipamentos">Todos</option>
                        <option value="Disponível">Disponível</option>
                        <option value="Em uso">Em uso</option>
                        <option value="Em manutenção">Em manutenção</option>
                    </select>
                </div>

                <div class="flex justify-end">
                    <button type="submit"
                        class="flex-1 sm:flex-none bg-blue-600 text-white px-6 py-2.5 rounded-lg hover:bg-blue-700 transition-all duration-200 transform hover:scale-105 flex items-center justify-center gap-2 font-medium shadow-lg w-full sm:w-auto ml-auto">
                        <Send class="w-5 h-5" />
                        <p>Gerar Relatório</p>
                    </button>
                </div>
            </form>
        </template>
    </ModalTemplate>

    <ModalTemplate v-if="showAddKitModal" @close="showAddKitModal = false">
        <template #header>Adicionar Novo Kit</template>
        <template #body>
            <form @submit.prevent="addKit" class="space-y-4">
                <div>
                    <label for="kitEquipamentos" class="block text-sm font-medium text-gray-700 dark:text-gray-300">
                        Selecione os Equipamentos
                    </label>
                    <!-- Campo de filtro para equipamentos -->
                    <div class="mb-2">
                        <input type="text" id="equipmentsFilter" v-model="filterEquipment"
                            placeholder="Filtrar equipamentos..."
                            class="w-full border rounded-lg px-4 py-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white mb-3" />
                    </div>
                    <select id="kitEquipamentos" v-model="newKit.equipamentos" multiple required
                        :disabled="allAvailableEquipments.length === 0"
                        class="w-full border rounded-lg px-4 py-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white mb-3">
                        <template v-if="filteredAllAvailableEquipments.length > 0">
                            <option v-for="equipment in filteredAllAvailableEquipments" :key="equipment.id"
                                :value="equipment.id">
                                {{ equipment.serial_number }} - {{ equipment.modelo_nome }} - {{ equipment.tipo }}
                            </option>
                        </template>
                        <template v-else>
                            <option disabled>Nenhum equipamento disponível</option>
                        </template>
                    </select>
                    <p class="mt-1 text-xs text-gray-500 dark:text-gray-400">
                        Segure a tecla Ctrl (Windows) ou Command (Mac) para selecionar múltiplos itens.
                    </p>
                </div>
                <div>
                    <label for="kitStatus" class="block text-sm font-medium text-gray-700 dark:text-gray-300">
                        Status
                    </label>
                    <select id="kitStatus" v-model="newKit.status" required
                        class="w-full border rounded-lg px-4 py-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white mb-3">
                        <option value="Disponível">Disponível</option>
                        <option value="Indisponível">Indisponível</option>
                        <option value="Em uso">Em Uso</option>
                        <option value="Em estoque">Em Estoque</option>
                    </select>
                </div>
                <div>
                    <label for="kitUnidade" class="block text-sm font-medium text-gray-700 dark:text-gray-300">
                        Unidade
                    </label>
                    <select id="kitUnidade" v-model="newKit.unidade" required
                        class="w-full border rounded-lg px-4 py-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white mb-3">
                        <option value="" disabled>Selecione uma unidade</option>
                        <option v-for="unidade in unidades" :key="unidade.id" :value="unidade.id">
                            {{ unidade.nome }}
                        </option>
                    </select>
                </div>
                <div>
                    <label for="kitSetor" class="block text-sm font-medium text-gray-700 dark:text-gray-300">
                        Setor
                    </label>
                    <select id="kitSetor" v-model="newKit.setor" required
                        :disabled="!newKit.unidade || filteredSetores.length === 0"
                        class="w-full border rounded-lg px-4 py-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white mb-3">
                        <option value="" disabled>
                            {{ !newKit.unidade ? 'Selecione uma unidade primeiro'
                            : (filteredSetores.length === 0 ? 'Nenhum setor disponível para essa unidade' : 'Selecione um setor') }}
                        </option>
                        <option v-for="setor in filteredSetores" :key="setor.id" :value="setor.id">
                            {{ setor.nome }}
                        </option>
                    </select>
                </div>
                <div>
                    <label for="kitResponsavel" class="block text-sm font-medium text-gray-700 dark:text-gray-300">
                        Responsável Interno (opcional)
                    </label>
                    <select id="kitResponsavel" v-model="selectedResponsavel"
                        class="w-full border rounded-lg px-4 py-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white mb-3">
                        <option value="">-- Selecione um responsável --</option>
                        <option v-for="usuario in usuarios" :key="usuario.id" :value="usuario.id">
                            {{ usuario.first_name }} {{ usuario.last_name }}
                        </option>
                    </select>
                </div>

                <div class="flex justify-end">
                    <button type="submit"
                        class="flex-1 sm:flex-none bg-blue-600 text-white px-6 py-2.5 rounded-lg hover:bg-blue-700 transition-all duration-200 transform hover:scale-105 flex items-center justify-center gap-2 font-medium shadow-lg w-full sm:w-auto">
                        <PlusCircle class="w-5 h-5" />
                        <p>Adicionar</p>
                    </button>
                </div>
            </form>
        </template>
    </ModalTemplate>

    <ModalTemplate v-if="showAddModelModal" @close="showAddModelModal = false">
        <template #header>Adicionar Novo Modelo</template>
        <template #body>
            <form @submit.prevent="addModel" class="space-y-4">
                <div>
                    <label for="modelNome" class="block text-sm font-medium text-gray-700 dark:text-gray-300">Nome do
                        Modelo</label>
                    <input type="text" id="modelNome" v-model="newModel.nome" placeholder="Digite o nome do modelo"
                        class="w-full border rounded-lg px-4 py-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white mb-3">
                </div>
                <div>
                    <label for="modelBrand"
                        class="block text-sm font-medium text-gray-700 dark:text-gray-300">Marca</label>
                    <select id="modelBrand" v-model="selectedMarca" required
                        class="w-full border rounded-lg px-4 py-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white mb-3">
                        <option value="" disabled>Selecione uma marca</option>
                        <option v-for="marca in marcas" :key="marca.id" :value="marca.nome">{{ marca.nome }}</option>
                    </select>
                </div>
                <div>
                    <label for="modelType"
                        class="block text-sm font-medium text-gray-700 dark:text-gray-300">Tipo</label>
                    <select id="modelType" v-model="selectedTipo" required
                        class="w-full border rounded-lg px-4 py-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white mb-3">
                        <option value="" disabled>Selecione um tipo</option>
                        <option v-for="tipo in tipos" :key="tipo.id" :value="tipo.nome">{{ tipo.nome }}</option>
                    </select>
                </div>
                <div class="flex justify-end">
                    <button type="submit"
                        class="flex-1 sm:flex-none bg-blue-600 text-white px-6 py-2.5 rounded-lg hover:bg-blue-700 transition-all duration-200 transform hover:scale-105 flex items-center justify-center gap-2 font-medium shadow-lg w-full sm:w-auto">
                        <PlusCircle class="w-5 h-5" />
                        <p>Adicionar</p>
                    </button>
                </div>
            </form>
        </template>
    </ModalTemplate>

    <transition name="modal">
        <div v-if="showEditModal" class="fixed inset-0 z-50 bg-black/50 dark:bg-black/70 flex items-center justify-center p-4">
            <div class="bg-white dark:bg-gray-800 rounded-xl shadow-xl w-full max-w-md p-6 animate-fade-in">
                <h3 class="text-xl font-bold text-gray-800 dark:text-white mb-4">
                    Editar Equipamento
                </h3>
                <div class="space-y-4">
                    <div>
                        <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                            Nome do Modelo
                        </label>
                        <input
                            v-model="editingEquipment.modelo_nome"
                            class="w-full px-4 py-2 rounded-lg border border-gray-300 dark:border-gray-600 dark:bg-gray-700 dark:text-white"
                        />
                    </div>
                    <div>
                        <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                            Tipo
                        </label>
                        <select
                            v-model="editingEquipment.tipo"
                            class="w-full px-4 py-2 rounded-lg border border-gray-300 dark:border-gray-600 dark:bg-gray-700 dark:text-white"
                        >
                            <option value="" disabled>Selecione um tipo</option>
                            <option v-for="tipo in tipos" :key="tipo.id" :value="tipo.nome">{{ tipo.nome }}</option>
                        </select>
                    </div>
                    <div>
                        <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                            Status
                        </label>
                        <select
                            v-model="editingEquipment.status"
                            class="w-full px-4 py-2 rounded-lg border border-gray-300 dark:border-gray-600 dark:bg-gray-700 dark:text-white"
                        >
                            <option value="Disponível">Disponível</option>
                            <option value="Em uso">Em uso</option>
                            <option value="Em manutenção">Em manutenção</option>
                        </select>
                    </div>
                    <div>
                        <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                            Host (Opcional)
                        </label>
                        <select
                            v-model="editingEquipment.host_id"
                            class="w-full px-4 py-2 rounded-lg border border-gray-300 dark:border-gray-600 dark:bg-gray-700 dark:text-white"
                        >
                            <option value="">Selecione um host (opcional)</option>
                            <option v-for="host in hosts" :key="host.id" :value="host.id">{{ host.nome }} ({{ host.ip_address }})</option>
                        </select>
                    </div>
                </div>
                <div class="flex justify-end gap-3 mt-6">
                    <button @click="closeEditModal" class="px-4 py-2 bg-gray-500 text-white rounded-lg hover:bg-gray-600">
                        Cancelar
                    </button>
                    <button @click="saveEditedEquipment" class="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700">
                        Salvar
                    </button>
                </div>
            </div>
        </div>
    </transition>
</template>

<script setup>
import { ref, computed, onMounted, watch } from 'vue';

const abaEquipamentosRef = ref(null);


import apiClient from '@/services/authService';
import { useRouter } from 'vue-router';

import BaseTemplate from '@/views/templates/BaseTemplate.vue';
import ModalTemplate from '@/views/templates/ModalTemplate.vue'; 
import { PlusCircle, Send} from 'lucide-vue-next';
import { jsPDF } from "jspdf";

// Importar componentes das abas
import AbaEquipamentos from './AbaEquipamentos.vue';
import AbaKits from './AbaKits.vue';
import AbaModelos from './AbaModelos.vue';




// Estado do modal de filtros
const showFilterModal = ref(false);
const showEditModal = ref(false);
const editingEquipment = ref(null);
const selectedResponsavel = ref(null);

// Estado local para substituir o Pinia
const activeTab = ref('equipments');
const filters = ref({
    equipment: {
        serial_number: '',
        tipo: '',
        modelo: '',
        status: '',
        unidade: '',
        token: '',
        responsavel_interno: ''
    },
    kit: {
        kit_code: '',
        status: '',
        unidade: '',
        setor: '',
        responsavel_interno: ''
    },
    model: {
        name: ''
    },

});

// Funções para gerenciar o estado local
const setActiveTab = async (tab) => {
    activeTab.value = tab;
    localStorage.setItem('ativos_active_tab', tab);
    await carregarMetricas();
};

const closeEditModal = () => {
    showEditModal.value = false;
};

// Função para aplicar os filtros
const applyFilters = (novosFiltros) => {
    if (activeTab.value === 'equipments') {
        filters.value.equipment = { ...novosFiltros };
    } else if (activeTab.value === 'kits') {
        filters.value.kit = { ...novosFiltros };
    }
    carregarMetricas();
    showFilterModal.value = false;
};

const showFilters = ref(false);
const sortColumn = ref('serial_number');
const sortDirection = ref('asc');
const sortBy = (column) => {
    if (sortColumn.value === column) {
        sortDirection.value = sortDirection.value === 'asc' ? 'desc' : 'asc';
    } else {
        sortColumn.value = column;
        sortDirection.value = 'asc';
    }
};

const selectedUnidade = ref("");
const selectedStatus = ref("");
const equipamentosRelatorio = ref([]);

const router = useRouter();

const goToGerarToken = () => {
    router.push({ name: "GerarToken" });
};

const gerarRelatorios = async () => {
    try {
        const unidadeSelecionada = selectedUnidade.value ? selectedUnidade.value.toString() : null;
        const params = {
                    unidade: unidadeSelecionada,
                    status: selectedStatus.value !== "Todos os Equipamentos" ? selectedStatus.value : null,
                    tipo: selectedTipo.value || null,
                    page_size: 10000
                };
        console.log(" Enviando requisição com params:", params);
        const response = await apiClient.get("/api/v1/actives/", { params });
        console.log("[GERAR RELATÓRIO] Dados recebidos do backend:", response.data);
        equipamentosRelatorio.value = response.data;
        console.log(" Relatório gerado:", equipamentosRelatorio.value);
        if (!equipamentosRelatorio.value.items || equipamentosRelatorio.value.items.length === 0) {
            alert(`Nenhum equipamento encontrado para a unidade ${unidadeSelecionada}.`);
            return;
        }
        gerarPDF(equipamentosRelatorio.value.items);
        showAddRelatoriosModal.value = false;
    } catch (error) {
        console.error("Erro ao gerar relatório:", error.response?.data || error);
    }
};

const usuarios = ref([]);

const fetchUsuarios = async () => {
    try {

        const response = await apiClient.get("/api/v1/auth/users");
        usuarios.value = response.data;
    } catch (error) {
        console.error("Erro ao buscar usuários:", error);
    }
};

onMounted(() => {
    activeTab.value = localStorage.getItem('ativos_active_tab') || 'equipments';

});

const gerarPDF = (dados) => {
    const doc = new jsPDF();
    const pageHeight = doc.internal.pageSize.height;
    const marginBottom = 20;
    let startY = 55;
    const headerHeight = 10;
    const rowHeight = 8;

    const unidadeSelecionadaId = selectedUnidade.value ? selectedUnidade.value.toString() : "Todas";
    const unidadeSelecionadaNome = unidades.value.find(u => u.id.toString() === unidadeSelecionadaId)?.nome || "Todas";

    if (!dados || dados.length === 0) {
        alert(`Nenhum equipamento encontrado para a unidade ${unidadeSelecionadaNome}.`);
        return;
    }

    const usuarioNome = `${sessionStorage.getItem("firstname")} ${sessionStorage.getItem("lastname")}` || "Desconhecido";

    try {
        const logoPath = "/logo_ccdti.png";  
        const logoWidth = 20;  
        const logoHeight = 6; 
        doc.addImage(logoPath, "PNG", 6, 3, logoWidth, logoHeight);
    } catch (error) {
        console.warn(" Não foi possível carregar a logo:", error);
    }

    doc.setFontSize(22);
    doc.text("Relatório de Ativos", 105, 25, { align: "center" });

    doc.setFontSize(10);
    doc.text(`Emitido por: ${usuarioNome}`, 105, 42, { align: "center" });
    doc.text(`Unidade: ${unidadeSelecionadaNome}`, 105, 49, { align: "center" });

    const desenharCabecalho = (doc, y) => {
        doc.setFillColor("#000000");
        doc.rect(10, y, 190, headerHeight, 'F');
        doc.setTextColor('#FFFFFF');
        doc.text("ID", 12, y + 7);
        doc.text("Unidade", 50, y + 7);
        doc.text("Modelo", 80, y + 7);
        doc.text("Serial", 120, y + 7);
        doc.text("Tipo", 150, y + 7);
        doc.text("Status", 180, y + 7);
        doc.setTextColor("#000000");
    };

    desenharCabecalho(doc, startY);
    startY += headerHeight;

    dados.forEach((ativo) => {
        if ((startY + rowHeight) > (pageHeight - marginBottom)) {
            doc.addPage();
            startY = 20;
            desenharCabecalho(doc, startY);
            startY += headerHeight;
        }

        const rowY = startY;

        const id = ativo.id ? ativo.id.toString() : "N/A";
        const unidade = ativo.kits?.[0]?.unidade || "N/A";
        const modelo = ativo.modelo_nome || "Não informado";
        const serial = ativo.serial_number || "N/A";
        const tipo = ativo.tipo || "Não especificado";
        const status = ativo.status || "Sem status";

        doc.text(id, 12, rowY + 6);
        doc.text(unidade, 50, rowY + 6);
        doc.text(modelo, 80, rowY + 6);
        doc.text(serial, 120, rowY + 6);
        doc.text(tipo, 150, rowY + 6);
        doc.text(status, 180, rowY + 6);

        startY += rowHeight;
    });

    let totalRowY = startY + 5;
    if ((totalRowY + 8) > (pageHeight - marginBottom)) {
        doc.addPage();
        totalRowY = 20;
    }
    doc.setFillColor("#EAEDED");
    doc.rect(10, totalRowY, 190, 8, 'F');
    doc.setFont("helvetica", "bold");
    doc.setTextColor("#000000");
    doc.text(`Total de Ativos: ${dados.length}`, 15, totalRowY + 6);

    doc.setFontSize(8);
    doc.text(" 2025 T.I CCDTI. Todos os direitos reservados", 105, pageHeight - 10, { align: "center" });

    const nomeArquivo = `relatorio_ativos_${unidadeSelecionadaNome.replace(/\s+/g, '_')}.pdf`;
    doc.save(nomeArquivo);
};

const dataInicio = ref('');
const dataFim = ref('');
const selectedPeriodo = ref('');

watch(selectedPeriodo, (newValue) => {
    if (newValue === 'customizado') {
        const today = new Date().toISOString().split('T')[0];
        dataInicio.value = today;
        dataFim.value = today;
    } else {
        dataInicio.value = '';
        dataFim.value = '';
    }
});

const equipments = ref([]);
const equipmentKits = ref([]);
const models = ref([]);
const marcas = ref([]);

const showAddRelatoriosModal = ref(false);
const tipos = ref([]);
const selectedTipo = ref("");
const selectedModelo = ref("");
const selectedMarca = ref("");
const showAddEquipmentModal = ref(false);
const showAddKitModal = ref(false);
const showAddModelModal = ref(false);
const setores = ref([]);
const unidades = ref([]);
const hosts = ref([]);
const filterEquipment = ref('');


const newEquipment = ref({
    serial_number: '',
    modelo_id: '',
    status: 'Disponível',
    host_id: null,
});

const newKit = ref({
    status: 'Disponível',
    setor: '',
    unidade: '',
    equipamentos: [],
    responsavel_interno: null
});

const newModel = ref({
    nome: '',
    marca: '',
    tipo: ''
});

const openModal = (type) => {
    showAddEquipmentModal.value = false;
    showAddRelatoriosModal.value = false;

    if (type === 'equipment') {
        showAddEquipmentModal.value = true;
        fetchModels();
        fetchTipos();
        fetchMarcas();
        fetchHosts();
    
    } else if (type === 'relatorio') {
        showAddRelatoriosModal.value = true;
        fetchUnidades();
    }
};

const fetchSetores = async () => {
    try {
        const response = await apiClient.get('/api/v1/enterprises/sectors/');
        setores.value = response.data;
    } catch (error) {
        console.error("Erro ao buscar setores:", error);
    }
};

const fetchUnidades = async () => {
    try {
          
        const response = await apiClient.get('/api/v1/enterprises/');
        unidades.value = response.data;
    } catch (error) {
        console.error("Erro ao buscar unidades:", error);
    }
};

const fetchModels = async () => {
    try {
    
        const response = await apiClient.get('/api/v1/actives/models/');
        models.value = response.data;
    } catch (error) {
        console.error("Erro ao buscar modelos:", error);
    }
};

const fetchMarcas = async () => {
    try {
        const response = await  apiClient.get('/api/v1/actives/brands/');
        marcas.value = response.data;
    } catch (error) {
        console.error("Erro ao buscar marcas:", error);
    }
};

const fetchTipos = async () => {
    try {

        const response = await apiClient.get('/api/v1/actives/types/');
        tipos.value = response.data;
    } catch (error) {
        console.error("Erro ao buscar tipos:", error);
    }
};

const fetchHosts = async () => {
    try {
        const response = await apiClient.get('/api/v1/actives/hosts/');
        hosts.value = response.data;
    } catch (error) {
        console.error("Erro ao buscar hosts:", error);
    }
};



const metricas = ref({
    equipamentos: {
        total: 0,
        disponiveis: 0,
        em_uso: 0,
        em_manutencao: 0
    },
    kits: {
        total: 0,
        disponiveis: 0,
        em_uso: 0
    }
});

const carregarMetricasAtivos = async (filtros = {}) => {
    try {
        const response = await apiClient.get('/api/v1/actives/metrics', { params: filtros });
        if (response.data && response.data.equipamentos) {
            metricas.value.equipamentos = response.data.equipamentos;
            console.log('Métricas de ativos carregadas:', response.data);
        }
    } catch (error) {
        console.error('Erro ao carregar métricas de ativos:', error);
    }
};

const carregarMetricasKits = async (filtros = {}) => {
    try {
        const response = await apiClient.get('/api/v1/kits/metrics', { params: filtros });
        if (response.data && response.data.kits) {
            metricas.value.kits = response.data.kits;
            console.log('Métricas de kits carregadas:', response.data);
        }
    } catch (error) {
        console.error('Erro ao carregar métricas de kits:', error);
    }
};

const carregarMetricas = async () => {
    console.log('Carregando métricas para a aba:', activeTab.value);
    if (activeTab.value === 'equipments') {
        // Monta o payload conforme esperado pela API
        const filtrosEquipamento = {};
        if (filters.value.equipment.serial_number) filtrosEquipamento.serial_number = filters.value.equipment.serial_number;
        if (filters.value.equipment.tipo) {
            // Buscar nome do tipo pelo id, se necessário
            const tipoObj = tipos.value.find(t => t.id == filters.value.equipment.tipo);
            filtrosEquipamento.tipo = tipoObj ? tipoObj.nome : filters.value.equipment.tipo;
        }
        if (filters.value.equipment.modelo) {
            // Buscar nome do modelo pelo id, se necessário
            const modeloObj = models.value.find(m => m.id == filters.value.equipment.modelo);
            filtrosEquipamento.modelo = modeloObj ? modeloObj.nome : filters.value.equipment.modelo;
        }
        if (filters.value.equipment.status) filtrosEquipamento.status = filters.value.equipment.status;
        if (filters.value.equipment.unidade) filtrosEquipamento.unidade = parseInt(filters.value.equipment.unidade, 10);
        if (filters.value.equipment.token) filtrosEquipamento.token = filters.value.equipment.token;
        if (filters.value.equipment.responsavel_interno) {
            filtrosEquipamento.responsavel_id = parseInt(filters.value.equipment.responsavel_interno, 10);
        }
        console.log('[carregarMetricas] Filtros enviados para métricas:', filtrosEquipamento);
        await carregarMetricasAtivos(filtrosEquipamento);
    } else if (activeTab.value === 'kits') {
        const filtrosKit = {};
        if (filters.value.kit.kit_code) filtrosKit.kit_code = filters.value.kit.kit_code;
        if (filters.value.kit.status) filtrosKit.status = filters.value.kit.status;
        if (filters.value.kit.unidade) filtrosKit.unidade = parseInt(filters.value.kit.unidade, 10);
        if (filters.value.kit.responsavel_interno) {
            filtrosKit.responsavel_id = parseInt(filters.value.kit.responsavel_interno, 10);
        }
        await carregarMetricasKits(filtrosKit);
    }
};

// Atualizar métricas quando mudar de aba
watch(activeTab, async (newTab, oldTab) => {
    console.log('Aba mudou de', oldTab, 'para', newTab);
    await carregarMetricas();
});

// Carregar métricas quando o componente for montado
onMounted(async () => {
    activeTab.value = localStorage.getItem('ativos_active_tab') || 'equipments';
    await carregarMetricas();

});

const activeMetrics = computed(() => {
    if (activeTab.value === 'equipments') {
        return [
            { label: 'Total de Equipamentos', value: metricas.value.equipamentos.total || 0, color: 'text-blue-600 dark:text-blue-400' },
            { label: 'Disponíveis', value: metricas.value.equipamentos.disponiveis || 0, color: 'text-green-600 dark:text-green-400' },
            { label: 'Em Uso', value: metricas.value.equipamentos.em_uso || 0, color: 'text-blue-600 dark:text-blue-400' },
            { label: 'Em Manutenção', value: metricas.value.equipamentos.em_manutencao || 0, color: 'text-yellow-600 dark:text-yellow-400' },
        ];
    } else if (activeTab.value === 'kits') {
        return [
            { label: 'Total de Kits', value: metricas.value.kits.total || 0, color: 'text-blue-600 dark:text-blue-400' },
            { label: 'Disponíveis', value: metricas.value.kits.disponiveis || 0, color: 'text-green-600 dark:text-green-400' },
            { label: 'Em Uso', value: metricas.value.kits.em_uso || 0, color: 'text-blue-600 dark:text-blue-400' },
        ];
    }
    return [];
});

const filteredSetores = computed(() => {
    const unidadeId = parseInt(newKit.value.unidade);
    if (!unidadeId) return [];
    return setores.value.filter(setor =>
        setor?.unidade?.id === unidadeId
    );
});



const allAvailableEquipments = ref([]);

const fetchAllAvailableEquipments = async () => {
    try {
        // Força a ausência de paginação com um page_size alto
        const response = await apiClient.get('/api/v1/actives/', {
            params: { status: 'Disponível', page_size: 10000 }
        });
        allAvailableEquipments.value = response.data.items || response.data;
    } catch (error) {
        console.error('Erro ao buscar todos os equipamentos disponíveis:', error);
        allAvailableEquipments.value = [];
    }
};

const filteredAllAvailableEquipments = computed(() => {
    if (!filterEquipment.value) return allAvailableEquipments.value;
    const search = filterEquipment.value.toLowerCase();
    return allAvailableEquipments.value.filter(equipment => {
        return (
            (equipment.serial_number && equipment.serial_number.toLowerCase().includes(search)) ||
            (equipment.modelo_nome && equipment.modelo_nome.toLowerCase().includes(search))
        );
    });
});

watch(showAddKitModal, (val) => {
    if (val) {
        fetchAllAvailableEquipments();
        fetchUsuarios();
        fetchSetores();
        fetchUnidades();
    }
});

watch(showAddModelModal, (val) => {
    if (val) {
        fetchMarcas();
        fetchTipos();
    }
});





const filteredModelsByTipo = computed(() => {
    if (!selectedTipo.value) return [];
    return models.value.filter(model => model.tipo.toLowerCase() === selectedTipo.value.toLowerCase());
});

import { defineEmits } from 'vue';
const emit = defineEmits(['equipment-added']);

const addEquipment = async () => {
    try {
        newEquipment.value.modelo_id = selectedModelo.value;
        const response = await apiClient.post('/api/v1/actives/', newEquipment.value);
        equipments.value.push(response.data);
        newEquipment.value = { name: '', serial_number: '', modelo_id: 0, status: 'Disponível', host_id: null, value: 0, lastMaintenance: '' };
        selectedTipo.value = "";
        selectedModelo.value = "";
        showAddEquipmentModal.value = false;
        emit('equipment-added'); // Emite evento personalizado
    } catch (error) {
        console.error("Erro ao adicionar equipamento:", error);
    }
    
    forceFullReload();
};

function forceFullReload() {
  window.location.reload();
}


const addModel = async () => {
    try {
              
        newModel.value.marca = selectedMarca.value;
        newModel.value.tipo = selectedTipo.value;
        const response = await apiClient.post('/api/v1/actives/models/', newModel.value);
        models.value.push(response.data);
        newModel.value = { nome: '', marca: '', tipo: '' };
        selectedMarca.value = "";
        selectedTipo.value = "";
        showAddModelModal.value = false;
    } catch (error) {
        console.error("Erro ao adicionar modelo:", error);
    }
    
};

const saveEditedEquipment = async () => {
    try {
        const payload = {
            serial_number: editingEquipment.value.serial_number,
            status: editingEquipment.value.status,
            host_id: editingEquipment.value.host_id || null,
            modelo_id: editingEquipment.value.modelo_id
        };

        // Se o tipo foi alterado, precisamos encontrar o tipo_id
        if (editingEquipment.value.tipo) {
            const tipoObj = tipos.value.find(t => t.nome === editingEquipment.value.tipo);
            if (tipoObj) {
                payload.tipo_id = tipoObj.id;
            }
        }

        await apiClient.put(`/api/v1/actives/${editingEquipment.value.id}/`, payload);
        showEditModal.value = false;
        editingEquipment.value = null;
        
        // Recarregar a lista de equipamentos
        forceFullReload();
    } catch (error) {
        console.error("Erro ao salvar equipamento:", error.response?.data || error);
        alert("Erro ao salvar equipamento. Verifique os dados e tente novamente.");
    }
};



const editEquipment = async (equipment) => {
    editingEquipment.value = { ...equipment };
    // Carregar listas necessárias para os selects
    await fetchTipos();
    await fetchHosts();
    showEditModal.value = true;
};

const verDetalhesAtivo = (id) => {
    router.push({ name: "AtivosDetalhes", params: { id } });
};

const verDetalhesKit = (id) => {
    router.push({ name: "KitsDetalhes", params: { id } });
};

const deleteEquipment = async (equipment) => {
    if (confirm("Deseja realmente excluir este equipamento?")) {
        try {        
            await apiClient.delete(`/api/v1/actives/${equipment.id}/`);
            equipments.value = equipments.value.filter(e => e.id !== equipment.id);
        } catch (error) {
            console.error("Erro ao excluir equipamento:", error);
        }
    }
    
    forceFullReload();
};


const editModel = async (model) => {
    const novoNome = prompt("Novo nome para o modelo:", model.nome);
    if (novoNome && novoNome !== model.nome) {
        try {
           
            const payload = { nome: novoNome };
            const response = await apiClient.put(`/api/v1/actives/models/${model.id}/`, payload);
            
            const index = models.value.findIndex(m => m.id === model.id);
            if (index !== -1) {
                models.value[index] = response.data;
            }

            } catch (error) {
            console.error("Erro ao editar modelo:", error.response?.data || error);
        }
    }
};

const deleteModel = async (model) => {
    if (confirm("Deseja realmente excluir este modelo?")) {
        try {           
            await apiClient.delete(`/api/v1/actives/models/${model.id}/`);
            models.value = models.value.filter(m => m.id !== model.id);
        } catch (error) {
            console.error("Erro ao excluir modelo:", error);
        }
    }
    
    forceFullReload();
};

const getTabName = (tab) => {
    switch (tab) {
        case 'equipments':
            return 'ATIVOS';
        case 'kits':
            return 'KITS';
        case 'models':
            return 'MODELOS';
        default:
            return '';
    }
};

const addKit = async () => {
    try {
        const payload = {
            status: newKit.value.status,
            setor: newKit.value.setor,
            unidade: newKit.value.unidade,
            equipamentos: newKit.value.equipamentos,
            responsavel_interno: selectedResponsavel.value
        };

        await apiClient.post('/api/v1/kits/create/', payload);
        showAddKitModal.value = false;
        
        // Limpar o formulário
        newKit.value = {
            status: 'Disponível',
            setor: '',
            unidade: '',
            equipamentos: [],
            responsavel_interno: null
        };
        selectedResponsavel.value = null;

        // Emitir evento de kit adicionado
        window.dispatchEvent(new Event('kit-adicionado'));

    } catch (error) {
        console.error("Erro ao adicionar kit:", error);
    }
};

</script>
